export const domain = {
  field_form_field_title: "Domain",
  field_label: "Domain",
  field_input_type: "Dropdown",
  field_related_dropdown: "Family",
  field_options: [
    "Consumer",
    "Customer Development",
    "Customer Operations",
    "Cyber Foundation",
    "Data Foundation",
    "DBO (People)",
    "DBO (Procurement)",
    "DBO (R&D)",
    "DBO (Supply Chain)",
    "Finance",
    "Tech Foundation",
  ],
  field_input: "Select Domain",
  field_message_ip_error_message: "Domain is mandatory",
  field_required: "1",
  field_dropdown_option_component: [
    {
      field_title: "",
      field_options: [],
    },
  ],
  field_editable: "",
  field_column_size: "",
  value: "domain",
};

export const family = {
  field_form_field_title: "Family",
  field_label: "Family",
  field_input_type: "Related Dropdown",
  field_related_dropdown: "Product",
  field_options: [],
  field_input: "Select Family",
  field_message_ip_error_message: "Family is mandatory",
  field_required: "1",
  field_dropdown_option_component: [
    {
      field_title: "Consumer",
      field_options: [
        "Consumer Services",
        "Creative & Media",
        "Engage",
        "Insights",
        "Product Innovation & Pack Design",
      ],
    },
    {
      field_title: "Customer Development",
      field_options: [
        "Category Management",
        "Customer Business Planning, JBP, Collaboration",
        "dCom Execution",
        "DT Execution",
        "Enterprise & Professional Sales",
        "MT Execution",
      ],
    },
    {
      field_title: "Customer Operations",
      field_options: [
        "Integrated Planning & Customer Connectivity",
        "Logistics",
        "Master Data Governance",
        "Order to Cash",
      ],
    },
    {
      field_title: "DBO (People)",
      field_options: [
        "Data Management & Insights",
        "Employee Performance",
        "Global Mobility",
        "JML",
        "Payroll",
        "Talent Acquisition ",
      ],
    },
    {
      field_title: "DBO (Procurement)",
      field_options: [
        "Forecasting",
        "Procurement Operations",
        "Risk Management",
        "Sourcing",
        "Supplier Management",
        "Sustainability & Environment",
        "Travel & Expense",
      ],
    },
    {
      field_title: "DBO (R&D)",
      field_options: [
        "Capture (Real World Experiment)",
        "Create (Product Development)",
        "Exploit (Data & Model Management)",
        "Portfolio Management",
        "Simulate (Virtual World Experiment)",
      ],
    },
    {
      field_title: "DBO (Supply Chain)",
      field_options: [
        "Make (In-House & 3P)",
        "Quality Management",
        "Safety",
        "Security",
      ],
    },
    {
      field_title: "Finance",
      field_options: [
        "Compliance & Audit",
        "External Reporting & Consolidation",
        "Finance Operations",
        "Legal",
        "Planning & Performance Management",
        "Tax & Treasury ",
      ],
    },
    {
      field_title: "Tech Foundation",
      field_options: [
        "Corporate Communication",
        "Employee & Collaboration Tech Experience",
        "Enterprise Platforms",
        "Facility Services",
        "Master Data Tech",
        "Risk & Compliance",
        "Technology Infrastructure",
        "Travel Services",
      ],
    },
    {
      field_title: "Cyber Foundation",
      field_options: [
        "Detect",
        "Govern",
        "Identify",
        "Protect",
        "Recover",
        "Respond",
      ],
    },
    {
      field_title: "Data Foundation",
      field_options: [
        "Analytical Solutions & Design (xOps)",
        "Data Enablement",
        "Data Science & AI",
      ],
    },
  ],
  field_editable: "",
  field_column_size: "",
};

export const product = {
  field_form_field_title: "Product",
  field_label: "Product",
  field_input_type: "Related Dropdown",
  field_related_dropdown: "",
  field_options: [],
  field_input: "Select Product",
  field_message_ip_error_message: "Product is mandatory",
  field_required: "1",
  field_dropdown_option_component: [
    {
      field_title: "Consumer Services",
      field_options: [
        "Ad Production Management",
        "Agency Operations & Management",
        "Consumer Data Management",
        "Digital Asset Management (Consumer)",
        "Experience Compliance",
      ],
    },
    {
      field_title: "Creative & Media",
      field_options: [
        "Creative Production",
        "Media Management & Optimisation",
        "Retail Media Management",
      ],
    },
    {
      field_title: "Engage",
      field_options: [
        "Advanced & Immersive Experiences",
        "Carelines (CEC)",
        "Community Management",
        "Direct Messaging (Email & SMS)",
        "Loyalty & Rewards",
        "Web Experience Management & Optimisation",
      ],
    },
    {
      field_title: "Insights",
      field_options: ["Briefing", "Signals"],
    },
    {
      field_title: "Product Innovation & Pack Design",
      field_options: [
        "Artwork Management",
        "Innovation Management",
        "Pack Design",
      ],
    },
    {
      field_title: "Category Management",
      field_options: [
        "Assortment & Shelf Optimisation",
        "Integrated NRM & Pricing",
        "Performance Management & Category Insights",
      ],
    },
    {
      field_title: "Customer Business Planning, JBP, Collaboration",
      field_options: [
        "Joint Business Planning & Collaboration",
        "Promotion Analytics & Optimisation",
        "Promotion Planning & Management",
      ],
    },
    {
      field_title: "dCom Execution",
      field_options: ["Content", "Performance & Execution", "Retail Media"],
    },
    {
      field_title: "DT Execution",
      field_options: [
        "DT Operations",
        "DT Route-to-Market & Marketplace",
        "Intelligent Cabinets & Operations",
      ],
    },
    {
      field_title: "Enterprise & Professional Sales",
      field_options: ["Digital Selling (OOH)", "Digital Selling (ULI, UFS)"],
    },
    {
      field_title: "MT Execution",
      field_options: [
        "CRM & Field Force Management",
        "Intelligent In-store Execution",
        "Retail POSM Management",
      ],
    },
    {
      field_title: "Integrated Planning & Customer Connectivity",
      field_options: [
        "Autonomous Planning & Customer Connectivity",
        "Integrated Forecast",
        "Integrated Supply Planning",
        "Plan Analytics",
      ],
    },
    {
      field_title: "Logistics",
      field_options: [
        "D2C Logistics",
        "Logistics Analytics",
        "Transportation Management",
        "Warehouse Management",
      ],
    },
    {
      field_title: "Master Data Governance",
      field_options: [
        "Customer Master",
        "Data Quality Governance",
        "Price Master",
        "Product Master",
      ],
    },
    {
      field_title: "Order to Cash",
      field_options: [
        "Cash & Collections Management",
        "Claims Management",
        "Credit Management",
        "Order to Invoice Management",
        "Sales Order Fulfilment",
      ],
    },
    {
      field_title: "Detect",
      field_options: ["Adverse Event Analysis", "Continuous Monitoring"],
    },
    {
      field_title: "Govern",
      field_options: [
        "Controls Assurance Posture",
        "Cyber Security Risk Management",
        "Policies, Standards & Governance",
        "Third Party Cyber Security Risk Management",
      ],
    },
    {
      field_title: "Identify",
      field_options: [
        "Asset Identification",
        "Asset Risk Assessment & Management",
        "Attack Surface Management",
        "Threat Intelligence",
      ],
    },
    {
      field_title: "Protect",
      field_options: [
        "Human Risk",
        "Insider Risk",
        "Offensive Security",
        "Platform Security",
        "Threat Vulnerability Management",
      ],
    },
    {
      field_title: "Recover",
      field_options: ["Incident Recovery Plan & Execution"],
    },
    {
      field_title: "Respond",
      field_options: [
        "Case Management & Triage",
        "Cyber Security Incident Management & Mitigation",
        "Forensics & Post-Incident Analysis",
      ],
    },
    {
      field_title: "Analytical Solutions & Design (xOps)",
      field_options: [
        "Automation (Data Foundation)",
        "Reporting (Data Foundation)",
        "Service Management, DataOps, DevOps, ML Ops",
        "Solution & Product Delivery",
        "Vendor Management & Outsourced Services",
      ],
    },
    {
      field_title: "Data Enablement",
      field_options: [
        "Data & Insights Democratisation",
        "Data Architecture & Engineering",
        "Data Governance (Data Foundation)",
        "Data Platform",
        "Data Strategy",
      ],
    },
    {
      field_title: "Data Science & AI",
      field_options: [
        "AI Assurance & Ethics",
        "AI Foundation",
        "AI Labs & Innovation",
        "AI Literacy",
        "AI Strategy",
        "Enterprise Data Science & AI Models",
      ],
    },
    {
      field_title: "Data Management & Insights",
      field_options: [
        "Employee Listening",
        "People Master Data",
        "Reporting (People)",
        "Workforce Planning",
      ],
    },
    {
      field_title: "Employee Performance",
      field_options: [
        "Health & Wellbeing",
        "Learning & Development",
        "Performance Management",
      ],
    },
    {
      field_title: "Global Mobility",
      field_options: ["International Assignment", "Short Term Assignment"],
    },
    {
      field_title: "JML",
      field_options: ["Joiners, Movers, Leavers"],
    },
    {
      field_title: "Payroll",
      field_options: ["Benefits & Reward", "Employee Pay", "Time & Attendance"],
    },
    {
      field_title: "Talent Acquisition",
      field_options: [
        "Contingent Workforce Recruitment",
        "Employee Recruitment",
      ],
    },
    {
      field_title: "Forecasting",
      field_options: ["Material Price Forecasting"],
    },
    {
      field_title: "Procurement Operations",
      field_options: [
        "Contracting",
        "Onboarding & Supplier Master Data",
        "Payments",
        "Supplier Collaboration",
        "Supplier Helpdesk",
        "Tea Operations",
      ],
    },
    {
      field_title: "Risk Management",
      field_options: ["Commodity Risk Management"],
    },
    {
      field_title: "Sourcing",
      field_options: [
        "E-Tendering",
        "Non-Strategic Sourcing",
        "Spend Analytics",
        "Supplier Scouting",
      ],
    },
    {
      field_title: "Supplier Management",
      field_options: [
        "Compliance & Reporting",
        "Supplier Quality Assurance",
        "Supplier Relationship Management",
        "Supplier Risk Management",
      ],
    },
    {
      field_title: "Sustainability & Environment",
      field_options: [
        "Collect & Compute",
        "Comply",
        "Sustainability Communication",
      ],
    },
    {
      field_title: "Travel & Expense",
      field_options: ["Cards Management", "Expense Management"],
    },
    {
      field_title: "Capture (Real World Experiment)",
      field_options: [
        "Scientific References & Documentation",
        "Study, Experiment & Test Management",
      ],
    },
    {
      field_title: "Create (Product Development)",
      field_options: [
        "Digital Asset Management (R&D)",
        "Product Management",
        "Substance Management",
      ],
    },
    {
      field_title: "Exploit (Data & Model Management)",
      field_options: [
        "Audit Management",
        "Data Governance (R&D)",
        "Data Ingestion & Storage",
        "Digital Content Development",
      ],
    },
    {
      field_title: "Portfolio Management",
      field_options: ["Above the Skin (Polaris)", "Below the Skin (Polaris)"],
    },
    {
      field_title: "Simulate (Virtual World Experiment)",
      field_options: [
        "Equivalence & Threshold",
        "Optimisation",
        "Simulation & Visualisation",
      ],
    },
    {
      field_title: "Make (In-House & 3P)",
      field_options: [
        "CM Management",
        "Industrial IoT",
        "Manufacturing Engineering",
        "Manufacturing Maintenance",
        "Materials & Inventory Management",
        "Production Operation",
      ],
    },
    {
      field_title: "Quality Management",
      field_options: [
        "Inbound Supplier Quality",
        "Logistics Quality",
        "Manufacturing Quality",
        "Marketplace/Consumer Quality",
        "Product Safety",
      ],
    },
    {
      field_title: "Safety",
      field_options: ["3P Safety", "Employee Safety", "Site Safety"],
    },
    {
      field_title: "Security",
      field_options: ["3P Security", "Employee Security", "Site Security"],
    },
    {
      field_title: "Compliance & Audit",
      field_options: [
        "Access Controls",
        "Controls Monitoring",
        "External Audit & Annual Reports",
        "Internal Audit",
      ],
    },
    {
      field_title: "External Reporting & Consolidation",
      field_options: [
        "ESG Reporting",
        "Financial Reporting (inc Consolidation)",
        "Interco Operations",
        "Local Statutory Reporting",
        "Non-SC Capex & Fixed Assets Management",
      ],
    },
    {
      field_title: "Finance Operations",
      field_options: [
        "BMI Operations",
        "CD Finance Services",
        "Finance Master Data Operations",
        "Non-SAP Finance Services",
        "Overheads Management",
        "SC Finance Services",
      ],
    },
    {
      field_title: "Legal",
      field_options: [
        "BI & Compliance Management",
        "Brand Protection",
        "Contract Lifecycle Management",
        "M&A",
        "Matter Management & Operationss",
        "Patents & IP",
        "Privacy",
      ],
    },
    {
      field_title: "Planning & Performance Management",
      field_options: [
        "Finance Info Model",
        "Financial Forecasting",
        "Management Reporting",
      ],
    },
    {
      field_title: "Tax & Treasury",
      field_options: [
        "Bank Management & Treasury Payments",
        "FCCR",
        "Forex Management",
        "Tax Operations",
      ],
    },
    {
      field_title: "Corporate Communication",
      field_options: ["External Comms", "Internal Comms"],
    },
    {
      field_title: "Employee & Collaboration Tech Experience",
      field_options: [
        "AI Go Wide",
        "Assistive Technology",
        "Employee Collaboration",
        "End User Computing",
        "Service Desk/Deskside Support",
      ],
    },
    {
      field_title: "Enterprise Platforms",
      field_options: [
        "Automation (Tech Foundation)",
        "ERP",
        "Integration",
        "IT for IT",
        "Low Code/No Code",
      ],
    },
    {
      field_title: "Facility Services",
      field_options: [
        "Building Services",
        "Employee Services",
        "Event Management",
        "Site Security Services",
        "Workplace Technologies",
      ],
    },
    {
      field_title: "Master Data Tech",
      field_options: ["Master Data Tech"],
    },
    {
      field_title: "Risk & Compliance",
      field_options: ["AI Assurance", "Control & Compliance"],
    },
    {
      field_title: "Technology Infrastructure",
      field_options: ["Cloud Services", "Secure Connectivity"],
    },
    {
      field_title: "Travel Services",
      field_options: ["Travel & Fleet"],
    },
  ],
  field_editable: "",
  field_column_size: "",
  value: "product",
};

